import { useSelector } from "react-redux";
import QueryInput from "src/components/QueryInput";
import TransactionsGrid from "src/components/TransactionsGrid/TransactionsGrid";
import { useDataTableState } from "src/hooks/useDataTableState";
import { ProgramId } from "src/models/BaseModel";
import { Transaction } from "src/models/TransactionModel";
import { RootState } from "src/store";
import { useGetDashboardTransactionsQuery } from "src/store/apis/Transactions";
import { constructFilterString } from "src/utility/utility";
import Config from "../../config";
import { columns, config } from "./columns";

const defaultProgramId = Object.keys(Config)[0];

export default function Transactions() {
  const {
    currentPage,
    setCurrentPage,
    setFilters,
    setFilterQuery,
    queryInputRef,
    dataColumns,
    filterQuery,
    filters,
    itemsPerPage,
  } = useDataTableState<Transaction>({
    columns,
    config,
  });

  const programId = useSelector((state: RootState) => state.auth.programId);

  const endpoint =
    Config[(programId as ProgramId) ?? defaultProgramId]?.transactionsEndpoint;

  const filter = filterQuery ?? constructFilterString(filters, programId);

  const { data, isLoading, isFetching, refetch } =
    useGetDashboardTransactionsQuery(
      {
        endpoint,
        pageNumber: currentPage,
        pageSize: itemsPerPage,
        filter,
      },
      { refetchOnMountOrArgChange: true },
    );

  return (
    <TransactionsGrid
      endpoint={endpoint}
      filter={filter}
      rowKey={({ siebelOrderId, dateCreated }) =>
        `${siebelOrderId}-${dateCreated}`
      }
      columns={dataColumns}
      dataSource={data?.result?.items ?? []}
      isLoading={isLoading || isFetching}
      refetch={refetch}
      currentPage={currentPage}
      onChangePage={setCurrentPage}
      onFilterChange={setFilters}
      totalItems={data?.result?.paginator?.totalItems ?? 0}
      prefixNode={
        <QueryInput
          ref={queryInputRef}
          onSearch={(query) => {
            refetch();
            setFilterQuery(query);
          }}
          options={columns.map((col) => ({
            label: col.key,
            value: col.key,
          }))}
        />
      }
    />
  );
}
